import React from "react";
import { Warning } from "@phosphor-icons/react";

/**
 * Iter-63.1 — Emergency delivery pause banner.
 *
 * Rendered in the app shell when
 * `platform.delivery_paused_globally === true`. Displays for every
 * internal role so admins are permanently aware new production
 * deliveries are halted. Never rendered on public landing pages.
 */
export default function EmergencyPauseBanner({ platform, user }) {
  if (!platform?.delivery_paused_globally) return null;
  const isInternal = user?.org_type === "internal";
  if (!isInternal) return null;
  const note = (platform.delivery_paused_note || "").trim();
  const at = platform.delivery_paused_at;
  return (
    <div
      data-testid="emergency-pause-banner"
      role="status"
      aria-live="polite"
      style={{
        background: "#7f1d1d",
        color: "#fef2f2",
        borderBottom: "2px solid #000",
        padding: "10px 16px",
        fontFamily: "'IBM Plex Mono', monospace",
        fontSize: 12,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        fontWeight: 700,
        display: "flex",
        alignItems: "center",
        gap: 8,
        flexWrap: "wrap",
      }}
    >
      <Warning size={14} weight="bold" />
      <span>Emergency delivery pause is ACTIVE — new production deliveries are halted.</span>
      {at && <span style={{ opacity: 0.75 }}>since {at}</span>}
      {note && <span style={{ opacity: 0.9 }}>· {note}</span>}
      <a
        href="/settings/platform"
        data-testid="emergency-pause-banner-resume"
        style={{
          marginLeft: "auto",
          color: "#fff",
          background: "#000",
          padding: "4px 10px",
          textDecoration: "none",
          border: "1px solid #fff",
        }}
      >
        Manage in Platform Settings
      </a>
    </div>
  );
}
